// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__1wo9g","sk-bouncedelay":"styles_sk-bouncedelay__1-DTg","bounce1":"styles_bounce1__2lV0e","bounce2":"styles_bounce2__1C0fU"};